import { Component, Inject, OnInit } from '@angular/core';
import { OregonWellDataService } from '../../../../services/oregon-well-data.service';
import { ActivatedRoute } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SampleViewModel } from '../../../../models/well/samples/sample.viewmodel';

@Component({
  selector: 'app-delete',
  templateUrl: './delete-samples.component.html',
  styleUrls: ['./delete-samples.component.scss']
})
export class DeleteSampleComponent implements OnInit {

  sampleViewModel: SampleViewModel = undefined;

  sampleId: number = 0;
  saved = false;
  postError = false;
  postErrorMessages = [];
  processing = false;

  ngOnInit() {
    // delete
  }

  constructor(private oregonWellDataService: OregonWellDataService, private route: ActivatedRoute, 
      @Inject(MAT_DIALOG_DATA) public data: number, public dialogRef: MatDialogRef<DeleteSampleComponent>) {

    this.processing = true;
    
    if(data != 0){
      this.sampleId = this.data;
    }

    this.oregonWellDataService.GetSampleDelete(this.sampleId).subscribe(result => {
      this.sampleViewModel = result;
      this.processing = false;
    },
      error => {
        this.oregonWellDataService.onHttpError(error);

        this.processing = false;
      }
    );
  }

  onSubmit() {
    this.processing = true;
    this.postError = false;
    this.oregonWellDataService.DeleteSample(this.sampleId).subscribe(
      result => {
        this.saved = true;
        this.processing = false;
        this.oregonWellDataService.showToastSucess("Sample was Deleted");
        this.dialogRef.close();
      },
      error => {
        console.log('delete error', this.sampleViewModel);
        this.postError = true;
        this.processing = false;
        this.postErrorMessages = this.oregonWellDataService.onHttpError(error);
        this.oregonWellDataService.showToastError("Sample was Not Deleted");
      }
    );
  } 

}
